import * as React from 'react';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';

import { cn } from '@blockworks/ui/utils';

import { Link } from '@/components/common';
import decodeEntities from '@/utils/functions/string/decode-entities';

export type BreadCrumbItem = {
    title: string;
    link?: string;
};

type BreadcrumbProps = {
    items: BreadCrumbItem[];
    className?: string;
};

const Breadcrumb = (props: BreadcrumbProps) => {
    const { items, className } = props;

    // Add default home page link if the items don't contain it.
    const breadcrumbItems =
        items.length === 0 || !items.find(item => item.title && item.title.toUpperCase() === 'HOME')
            ? [{ title: 'home', link: '/' }, ...items]
            : items;

    return (
        <nav aria-label="breadcrumb">
            <ol className={cn('flex flex-row gap-2 text-brand uppercase text-sm text-left', className)}>
                {breadcrumbItems.map((item, index) => (
                    <li key={`li-${index}`} className="flex flex-row flex-grow-0 flex-shrink-0 items-center">
                        <Link href={item.link || ''}>{decodeEntities(item.title)}</Link>
                        {index !== breadcrumbItems.length - 1 && <ChevronLeftIcon className="w-3 h-3 ml-2" />}
                    </li>
                ))}
            </ol>
        </nav>
    );
};

export default Breadcrumb;
